import React from 'react'
import PropTypes from 'prop-types'
import { CardHeading } from '@components/layout/Card'

const Root = ({ title, subheader, children }) => {
  return (
    <CardHeading className='flex flex-wrap justify-between items-center'>
      <div className='flex flex-col flex-[2]'>
        <h5 className=''>{title}</h5>
        {subheader ? subheader : null}
      </div>
      {children}
    </CardHeading>
  )
}

const Filter = ({ filter, view }) => {
  if (!filter) return null
  return (
    <div className='flex-1'>
      {view ? filter(view) : filter()}
    </div>
  )
}

export const TabHeader = Object.assign(Root, {
  Filter,
})

TabHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subheader: PropTypes.node,
  children: PropTypes.node,
}
